import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { mapRecipients } from 'src/utils/utility-functions';

export const useMappedRecipients = (): [any[], any[]] => {
  const { caseParties, creditors, userUploadedAddresses, caseSource } = useSelector(
    (state: RootState) => state.upload.formData,
  );

  return useMemo(() => {
    const mixedCreditors = [
      ...(caseSource.masterMailingMatrix ? creditors : []),
      ...(caseSource.userSupplied ? userUploadedAddresses : []),
    ];
    return mapRecipients(caseParties, mixedCreditors);
  }, [caseParties, creditors, userUploadedAddresses, caseSource]);
};
